import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ArrowRightIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M20 12.4v-.8l-.3-.3-7-7a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.5l5.3 5.3H5a1 1 0 0 0-1 1c0 .5.5 1 1 1h11.6l-5.4 5.3a1 1 0 0 0 0 1.4 1 1 0 0 0 1.5 0l7-7 .3-.4Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ArrowRightIcon;
